import {removeEventFromEvents} from '@/redux-store/slices/events';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';
import {emitEventChangeEvent} from './change-observable';

export const deleteEvent = async (eventId: string) => {
  const response = await keycloakAxios.delete(`/event/${eventId}`);

  if (response.status >= 300 || response.data.message !== 'Event got deleted') {
    throw new Error(
      `Error deleting event: ${
        response.statusText !== 'Event got deleted'
          ? 'Unexpected response message'
          : `Invalid status code: ${response.status}`
      }`
    );
  }

  emitEventChangeEvent({
    type: 'deleted',
    id: eventId
  });

  store.dispatch(removeEventFromEvents(eventId));

  return response.data;
};
